import { InjectionToken } from '@angular/core';
import type * as Rx from 'rxjs';

export const WEBSOCKET_TEST_SCHEDULER = new InjectionToken<Rx.SchedulerLike>(
  'WebsocketTestScheduler',
);

export const RECONNECT_CONFIG = new InjectionToken<Rx.SchedulerLike>(
  'Reconnect Configuration',
);

export const RANDOM_NUMBER_PROVIDER = new InjectionToken<Rx.SchedulerLike>(
  'Random Number Provider',
);

export enum OnMessageTrackedEventTypes {
  MESSAGES_PRIVATE = 'messages-private',
}

export const ON_MESSAGE_TRACKING_CONFIG: {
  readonly [index: string]: boolean;
} = {
  [OnMessageTrackedEventTypes.MESSAGES_PRIVATE]: true,
};

/**
 * List of users who's websocket messages for the messaging product are being tracked. This is temporary and will be removed.
 *
 * @see T271701
 */
export const ON_MESSAGE_TRACKING_USER_CONFIG = new Set([
  // Users we are logged in as on test devices and tracking
  26707374, 1089884, 1646166, 10408748, 16629674,
  // AnilRecruiter
  58349233,

  // Users who complained about messaging performance/reliability
  60808159, 4076136, 15782095, 15555206, 34401494, 55019610, 27183142, 23186969,
  28089368, 25391384, 58061229, 13424957, 212547, 21226429, 60541789, 33028117,
  59833470, 52418007, 13299756, 58482303, 57538014, 7920909, 40902720,

  59924844, 48713282,

  // Support agents
  35863928, 46346499, 23989804, 54084163, 21571175, 11297398, 19686403,

  // Messaging team
  55950625, 56658423, 30609349, 21178223, 31575919, 53656246, 52769470,
]);
